import * as local from './local';
import * as development from './development';
import * as staging from './staging';
import * as production from './production';
import { common } from './common.js';

function makeConfig(env = '') {
    switch (env.toUpperCase()) {
        case 'PRODUCTION':
            return compose(production);
        case 'STAGING':
            return compose(staging);
        case 'DEVELOPMENT':
            return compose(development);
        default:
            return compose(local);
    }
}

function compose(config) {
    return {
        ...common,
        ...config,
    };
}

export default makeConfig(process.env.PRJ_ENV);
